/**
 * SecretRevealOnce — show a plaintext secret (API key) exactly once, right
 * after create/refresh. The backend never returns it again after this
 * response, so this is the only chance to copy it.
 */
import { el } from "../utils/dom";
import { showToast } from "./toast";

export function renderSecretReveal(secret: string, label = "API key"): HTMLElement {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      showToast("Copied to clipboard.", "success");
    } catch {
      showToast("Couldn't copy automatically. Select the key and copy it yourself.", "error");
    }
  };

  return el("div", { className: "panel panel--dominant" }, [
    el("p", { className: "panel__title" }, [label]),
    el("p", { className: "panel__description" }, [
      "This key is shown once. Copy it now; you will not be able to see it again after you leave.",
    ]),
    el("div", { className: "secret-reveal__row" }, [
      el("input", {
        className: "input input--mono",
        type: "text",
        readonly: true,
        value: secret,
        onclick: (ev: Event) => (ev.target as HTMLInputElement).select(),
      }),
      el("button", { className: "btn btn-primary btn-sm", type: "button", onclick: () => void copy() }, ["Copy"]),
    ]),
  ]);
}
